export default {
  mounted() {
    this.formatCurrency(this.el.dataset.amount, this.el.dataset.currency)
  },
  updated() {
    this.formatCurrency(this.el.dataset.amount, this.el.dataset.currency)
  },
  formatCurrency(amount, currency) {
    // Stripe amounts are in the smallest currency unit (e.g., cents)
    let value = parseFloat(amount)

    // Get locale from the browser
    let locale = navigator.language || 'en-US'

    // Use the Intl.NumberFormat API to format the currency
    let formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0, // Don't show any decimal places
      maximumFractionDigits: 0, // Don't show any decimal places
    })

    // Set the formatted currency amount in the element's innerText
    this.el.innerText = formatter.format(value)
  },
}
